import { RedoIncrementDecrement } from "@redotech/redo-web/arbiter-components/increment-decrement/redo-increment-decrement";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useEffect, useState } from "react";

export const WeightStepInput = memo(function WeightStepInput({
  setMatchValue,
  matchValue,
}: {
  setMatchValue: (matchValue: number) => void;
  matchValue: number | undefined;
}) {
  const [lbs, setLbs] = useState(Math.floor((matchValue || 0) / 16));
  const [oz, setOz] = useState((matchValue || 0) % 16);

  useEffect(() => {
    setMatchValue(oz + lbs * 16);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oz, lbs]);

  return (
    <Flex align="center" dir="row" gap="md" wrap="wrap">
      <RedoIncrementDecrement
        min={0}
        placeholder="0"
        selectOnFocus
        setValue={setLbs}
        size="small"
        step="any"
        suffix="lbs"
        value={lbs}
      />
      <RedoIncrementDecrement
        min={0}
        placeholder="0"
        selectOnFocus
        setValue={setOz}
        size="small"
        step="any"
        suffix="oz"
        value={oz}
      />
    </Flex>
  );
});
